import React, { FC, useContext, useMemo } from 'react';
import { useIntParams } from '../../hooks/useIntParams';
import { Nothing } from '../Nothing/Nothing';
import { useParams } from 'react-router-dom';
import { ProductVersionInstallerDownloads } from '../Downloads/ProductVersionInstallerDownloads';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import { PageHeader } from '../PageHeader/PageHeader';
import { useTranslation } from 'react-i18next';
import { UserDownloadsFetcher } from '../../fetchers/UserDownloadsFetcher';
import { AuthenticatedRoutes } from '../../routers/AuthenticatedRoutes';

interface IParams {
  product: string;
  version: string;
  installer: string;
}

export const DownloadsProductInstallerPage: FC = () => {
  const { data: downloads } = useContext(UserDownloadsFetcher.Context);

  const { product } = useIntParams<IParams>();
  const { version: minorVersion, installer: installerPattern } = useParams<IParams>();

  const { t } = useTranslation();

  const productDownloads = downloads?.userDownloads.find((userDownloads) => userDownloads.product.id === product);

  const installers = useMemo(() => {
    const pattern = new RegExp(
      '^' + // string start
        installerPattern.replaceAll('.', '\\.') + // escape dots
        '([^\\d]|$)' // make sure next character is not a digit (not to show 22.3.10 when the pattern is 22.3.1)
    );
    return productDownloads?.versions
      .find((version) => version.version === minorVersion)
      ?.installers.filter((installer) => installer.manifestFileVersion.version.match(pattern));
  }, [productDownloads]);

  return (
    <div>
      <PageHeader
        title={`${productDownloads?.product.name ?? ''} ${installerPattern}`}
        crumbs={[
          {
            title: t('layout.navigation.downloads'),
            url: AuthenticatedRoutes.UserDownloadsProductVersion(product, minorVersion),
          },
        ]}
      />
      {installers && installers.length ? (
        <Grid container spacing={1}>
          {installers.map((installer) => (
            <Grid item xs={12} key={installer.manifestFileVersion.version}>
              <Card>
                <ProductVersionInstallerDownloads installer={installer} />
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : downloads === null ? null : (
        <Nothing organizationContext={true} />
      )}
    </div>
  );
};
